
import axios from "axios";
import { BACKEND_URL } from "../constants";




export const login_web_request = async ({email, password}) => {
  
    const { data } = await axios.post(`${BACKEND_URL}/login-web`, {
      email,
      password
    }, {withCredentials: true});
    return data
  };


export const logout_web_request = async () => {
    const { data } = await axios.post(`${BACKEND_URL}/logout-web`, {}, { withCredentials: true });
    return data
  };



  export const forgot_password_send_mail = async ({email}) => {
    const { data } = await axios.post(`${BACKEND_URL}/forgot-password-send-mail`, {
      email
    }, { withCredentials: true})

    return data
  }


  export const forgot_password_set_new_password = async ({password, token}) => {
    const { data } = await axios.post(`${BACKEND_URL}/forgot-password-set-new-password`, {
      password,
      token
    }, {withCredentials: true})

    return data
  }

